var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"item"},[_c('p',[_c('span',[_vm._v(_vm._s(_vm.$t("message.deliveryNoteNumber"))+":")]),_vm._v(" "+_vm._s(_vm.detail.porder_sn)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }